import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { ASSET_CONTENT_TYPES } from './constants';
import { FILE_FORMATS, DOCUMENT_CONTENT_TYPES, MEDIA_CONTENT_TYPES, CONTENT_TYPES } from 'utils/asset/constants';
export var checkIfSubtitlesWereChanged = function checkIfSubtitlesWereChanged(defaultValue, newValue) {
  var initialValueIds = defaultValue.map(function (item) {
    return item.id;
  }).sort().join(',');
  var valueIds = newValue.map(function (item) {
    return item.id;
  }).sort().join(',');
  var initialValueLanguages = defaultValue.map(function (item) {
    return item.locale;
  }).sort().join(',');
  var valueLanguages = newValue.map(function (item) {
    return item.locale;
  }).sort().join(',');
  return initialValueIds !== valueIds || initialValueLanguages !== valueLanguages;
};
export var checkIfScormSettingsWereChanged = function checkIfScormSettingsWereChanged(defaultValue, newValue) {
  return JSON.stringify(defaultValue) !== JSON.stringify(newValue);
};
export function getAssetContentType(_ref) {
  var type = _ref.type,
    fileFormat = _ref.fileFormat;
  var assetContentType = ASSET_CONTENT_TYPES.ASSET;
  if (type === CONTENT_TYPES.WEBLINK) {
    assetContentType = ASSET_CONTENT_TYPES.WEBLINK;
  } else if (type === CONTENT_TYPES.EVENT) {
    assetContentType = ASSET_CONTENT_TYPES.EVENT;
  } else if (type === CONTENT_TYPES.UPLOAD) {
    if (fileFormat && DOCUMENT_CONTENT_TYPES.includes(fileFormat)) {
      assetContentType = ASSET_CONTENT_TYPES.DOCUMENT;
    }
    if (fileFormat === FILE_FORMATS.ASSET) {
      assetContentType = ASSET_CONTENT_TYPES.FILE;
    } else if (fileFormat && MEDIA_CONTENT_TYPES.includes(fileFormat)) {
      assetContentType = fileFormat;
    }
  } else if (type === CONTENT_TYPES.MICROSITE) {
    assetContentType = ASSET_CONTENT_TYPES.MICROSITE;
  } else if (type === CONTENT_TYPES.SCORM) {
    assetContentType = ASSET_CONTENT_TYPES.SCORM;
  }
  return assetContentType;
}